import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useDialogFormStore } from '@/components/dialog/form.store';

import { PointsTransferData } from '@/services/pointsTransfer/pointsTransfer.types';
import { ManagePoints } from '../forms/ManagePoints';
import { getColumns } from './Column';
import { useDynamicLocale } from '@/hoslog-intl';

export function PointsTransferLogs({ data }: { data: PointsTransferData[] }) {
  const { onOpen } = useDialogFormStore();
  const { t } = useDynamicLocale();

  const columns = React.useMemo(() => getColumns(t), [t]);
  const onAddnew = () => {
    onOpen({
      modalTitle: null,
      title: t('pointManagement.page.form.managePoints.title'),
      okText: t('common.page.modal.confirm'),
      size: 'lg',
      cancelText: t('common.page.modal.no'),
      component: <ManagePoints />,
    });
  };
  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: t('pointManagement.sidebar.menu.pointsTransfer'),
      action: onAddnew,
    },
    getRowId: (originalRow: PointsTransferData) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
